// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  background-color: #171727;
  /* height: 40rem; */
  width: 100%;
}

.img-cont {
  background-color: #f6f7f8;
}

.textgrey{
  color: #b5b5b5;
}
.product-image {
  width: 100%;
  height: 100%;
}
.greytext{
  color: #b5b5b5;
}
.buy-from-amazon_text{
  color: black;
}
.graish_text{
  color: #4f4444;
}

.product-image-multiple {
  /* width: 100px;
  height: 63px; */
  /* margin-top: 3%; */
  width: 17%;
    height: 100%;
}
.product-image-multiple-container {
      bottom: -8%;
}
/* .product-image,
.product-image-multiple {
  max-width: 100%;
  height: auto;
} */
.buttom {
  margin-bottom: 0px;
}

.intrashieldcontainer {
  color: #101010;
}

.product-cont {
  background-color: #e3e7f2;
}

.sku-text {
  color: #616161;
}

.desc-width {
  width: 500px;
  color: #101010;
}

.rating {
  background-color: #ffcd07;
}

.delivery-charge-price {
  color: #003cff;
}

.update-price-container {
border: 2px solid black;
  /* width: 120px; */
  /* height: 42px; */
}

.plus-qty {
  padding: 0px 10px 0px 10px;
  cursor: pointer;
  border: none;
  background-color: #e3e7f2;
}
.add-to-cart_text{
  background-color: #101010;
}
.addtocart-container {
  width: 250px;
  height: auto;
  /* margin-left: 10px; */
  padding: 10px;
  background-color: #101010;
}


.buy-from-amazon {
  
margin-top: 10px;
  cursor: pointer;
}

.four-image {
  width: 270px;
}

.eye-image {
  width: 800px;
}

.eye-text {
  padding: 60px;
  font-size: 22px;
}

.txt-color {
  color: #1f1d1b;
}
.bg-eye {
  background-color: #cdbfbc;
}
.application-image {
  width: 156px;
  /* margin-left: 22px; */
}
.application-image-2 {
  width: 156px;
  /* margin-left: 22px; */
}
.application-text {
  padding: 92px 0px 0px 0px;
  margin-bottom: 0;
}
.color-txt {
  color: #cdbfbc;
}
.table_div {
  height: 380px;
}
.product-specifion {
  background-color: #f1e8e6;
  /* margin-top: 13.8%; */
  height: auto;
}
.product-specifion-image {
  width: 170px;
  
}
th {
  color: #cdbfbc;
}
td {
  color: #cdbfbc;
}
.world-class-text {
  color: #616161;

}


.revo-image {
  width: 100%;
  opacity: 1;
}
.revo-image-2 {
  width: 100%;
}
.certification_font {
  font-size: 28px;
}
.certificate_img img{
  border-radius: 25px;
opacity: 0.6;
}
.certificate_img img:hover{
opacity: 1;
}

.product-image-multiple-container::-webkit-scrollbar {
  width: 1px;
  display: none;            
}
.product-image-multiple-container::-webkit-scrollbar-track-piece:end {
  display: none;
}
.product-image-multiple-container::-webkit-scrollbar-track {
  background: white;
}


.product-image-multiple-container::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 1px solid green;
  /* background-color: red; */
  
 
}

@media only screen and (max-width: 768px) {


  .main-container {
      background-color: #171727;
      height: 100%;
      width: 100%;
    }
  .application-image {
      width: 120px;
      /* margin-left: 22px; */
    }
  
    .application-image-2 {
      width: 120px;
      /* margin-left: 22px; */
    }
}

@media only screen and (max-width: 640px) {
  .main-container {
      background-color: #171727;
      height: 100%;
      width: 100%;
    }
  .addtocart-container {
    font-size: 13px;
    width: 200px;
    /* height: 43px; */
    margin-left: 10px;
  }
  .certification_font {
    font-size: 19px;
  }
  .product-specifion {
    background-color: #f1e8e6;
    margin-top: 0%;
  
  }
  .eye-text {
   
    font-size: 17px;
  }
  .product-image {
    width: 100%;
    height: auto;
    margin-top: 6%;
   
  }
  .buy-from-amazon {
  font-size: 12px;
    margin-top: 5px;
      cursor: pointer;
    }
    .product-image-multiple-container {
      bottom: -7%;
      margin-right: 0%;
}
}
.check-certification{
      display: flex;
        flex-flow: row-reverse;
        margin-top: 11px;
        margin-right: 13px;
}

.tech-card-girl{
  border: 6px solid #0d84fa;
  border-radius: 50%;
}


.loader {
  height: 4px;
  width: 130px;
  --c: no-repeat linear-gradient(black 0 0);
  background: var(--c), var(--c), #f6f7f8;
  background-size: 60% 100%;
  animation: l16 3s infinite;
}

@keyframes l16 {
  0% {
    background-position: -150% 0, -150% 0
  }

  66% {
    background-position: 250% 0, -150% 0
  }

  100% {
    background-position: 250% 0, 250% 0
  }
}`, "",{"version":3,"sources":["webpack://./src/component/Product/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE;iBACe;EACf,oBAAoB;EACpB,UAAU;IACR,YAAY;AAChB;AACA;MACM,WAAW;AACjB;AACA;;;;GAIG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;AACA,uBAAuB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;;AAGA;;AAEA,gBAAgB;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,YAAY;;AAEd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;;AAEhB;;;AAGA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB,YAAY;AACZ;AACA;AACA,UAAU;AACV;;AAEA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;;;AAG7B;;AAEA;;;EAGE;MACI,yBAAyB;MACzB,YAAY;MACZ,WAAW;IACb;EACF;MACI,YAAY;MACZ,uBAAuB;IACzB;;IAEA;MACE,YAAY;MACZ,uBAAuB;IACzB;AACJ;;AAEA;EACE;MACI,yBAAyB;MACzB,YAAY;MACZ,WAAW;IACb;EACF;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,cAAc;;EAEhB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;;EAEhB;EACA;EACA,eAAe;IACb,eAAe;MACb,eAAe;IACjB;IACA;MACE,WAAW;MACX,gBAAgB;AACtB;AACA;AACA;MACM,aAAa;QACX,sBAAsB;QACtB,gBAAgB;QAChB,kBAAkB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,uCAAuC;EACvC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF","sourcesContent":[".main-container {\n  background-color: #171727;\n  /* height: 40rem; */\n  width: 100%;\n}\n\n.img-cont {\n  background-color: #f6f7f8;\n}\n\n.textgrey{\n  color: #b5b5b5;\n}\n.product-image {\n  width: 100%;\n  height: 100%;\n}\n.greytext{\n  color: #b5b5b5;\n}\n.buy-from-amazon_text{\n  color: black;\n}\n.graish_text{\n  color: #4f4444;\n}\n\n.product-image-multiple {\n  /* width: 100px;\n  height: 63px; */\n  /* margin-top: 3%; */\n  width: 17%;\n    height: 100%;\n}\n.product-image-multiple-container {\n      bottom: -8%;\n}\n/* .product-image,\n.product-image-multiple {\n  max-width: 100%;\n  height: auto;\n} */\n.buttom {\n  margin-bottom: 0px;\n}\n\n.intrashieldcontainer {\n  color: #101010;\n}\n\n.product-cont {\n  background-color: #e3e7f2;\n}\n\n.sku-text {\n  color: #616161;\n}\n\n.desc-width {\n  width: 500px;\n  color: #101010;\n}\n\n.rating {\n  background-color: #ffcd07;\n}\n\n.delivery-charge-price {\n  color: #003cff;\n}\n\n.update-price-container {\nborder: 2px solid black;\n  /* width: 120px; */\n  /* height: 42px; */\n}\n\n.plus-qty {\n  padding: 0px 10px 0px 10px;\n  cursor: pointer;\n  border: none;\n  background-color: #e3e7f2;\n}\n.add-to-cart_text{\n  background-color: #101010;\n}\n.addtocart-container {\n  width: 250px;\n  height: auto;\n  /* margin-left: 10px; */\n  padding: 10px;\n  background-color: #101010;\n}\n\n\n.buy-from-amazon {\n  \nmargin-top: 10px;\n  cursor: pointer;\n}\n\n.four-image {\n  width: 270px;\n}\n\n.eye-image {\n  width: 800px;\n}\n\n.eye-text {\n  padding: 60px;\n  font-size: 22px;\n}\n\n.txt-color {\n  color: #1f1d1b;\n}\n.bg-eye {\n  background-color: #cdbfbc;\n}\n.application-image {\n  width: 156px;\n  /* margin-left: 22px; */\n}\n.application-image-2 {\n  width: 156px;\n  /* margin-left: 22px; */\n}\n.application-text {\n  padding: 92px 0px 0px 0px;\n  margin-bottom: 0;\n}\n.color-txt {\n  color: #cdbfbc;\n}\n.table_div {\n  height: 380px;\n}\n.product-specifion {\n  background-color: #f1e8e6;\n  /* margin-top: 13.8%; */\n  height: auto;\n}\n.product-specifion-image {\n  width: 170px;\n  \n}\nth {\n  color: #cdbfbc;\n}\ntd {\n  color: #cdbfbc;\n}\n.world-class-text {\n  color: #616161;\n\n}\n\n\n.revo-image {\n  width: 100%;\n  opacity: 1;\n}\n.revo-image-2 {\n  width: 100%;\n}\n.certification_font {\n  font-size: 28px;\n}\n.certificate_img img{\n  border-radius: 25px;\nopacity: 0.6;\n}\n.certificate_img img:hover{\nopacity: 1;\n}\n\n.product-image-multiple-container::-webkit-scrollbar {\n  width: 1px;\n  display: none;            \n}\n.product-image-multiple-container::-webkit-scrollbar-track-piece:end {\n  display: none;\n}\n.product-image-multiple-container::-webkit-scrollbar-track {\n  background: white;\n}\n\n\n.product-image-multiple-container::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  border: 1px solid green;\n  /* background-color: red; */\n  \n \n}\n\n@media only screen and (max-width: 768px) {\n\n\n  .main-container {\n      background-color: #171727;\n      height: 100%;\n      width: 100%;\n    }\n  .application-image {\n      width: 120px;\n      /* margin-left: 22px; */\n    }\n  \n    .application-image-2 {\n      width: 120px;\n      /* margin-left: 22px; */\n    }\n}\n\n@media only screen and (max-width: 640px) {\n  .main-container {\n      background-color: #171727;\n      height: 100%;\n      width: 100%;\n    }\n  .addtocart-container {\n    font-size: 13px;\n    width: 200px;\n    /* height: 43px; */\n    margin-left: 10px;\n  }\n  .certification_font {\n    font-size: 19px;\n  }\n  .product-specifion {\n    background-color: #f1e8e6;\n    margin-top: 0%;\n  \n  }\n  .eye-text {\n   \n    font-size: 17px;\n  }\n  .product-image {\n    width: 100%;\n    height: auto;\n    margin-top: 6%;\n   \n  }\n  .buy-from-amazon {\n  font-size: 12px;\n    margin-top: 5px;\n      cursor: pointer;\n    }\n    .product-image-multiple-container {\n      bottom: -7%;\n      margin-right: 0%;\n}\n}\n.check-certification{\n      display: flex;\n        flex-flow: row-reverse;\n        margin-top: 11px;\n        margin-right: 13px;\n}\n\n.tech-card-girl{\n  border: 6px solid #0d84fa;\n  border-radius: 50%;\n}\n\n\n.loader {\n  height: 4px;\n  width: 130px;\n  --c: no-repeat linear-gradient(black 0 0);\n  background: var(--c), var(--c), #f6f7f8;\n  background-size: 60% 100%;\n  animation: l16 3s infinite;\n}\n\n@keyframes l16 {\n  0% {\n    background-position: -150% 0, -150% 0\n  }\n\n  66% {\n    background-position: 250% 0, -150% 0\n  }\n\n  100% {\n    background-position: 250% 0, 250% 0\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
